<section class="destination-flight-info relative ms-large-y">
  @if (picture(); as picture) {
    <fin-content-image
      class="destination-flight-info__image relative"
      [imageData$]="picture | finToObservable"
      [fillParent]="true"
    />
  }

  <div
    class="destination-flight-info__card white-bg frost elevation-level-1 overflow-hidden nordic-blue-900-text text-icon-primary g-medium ps-large"
  >
    @if (startingFromPrice(); as price) {
      <div class="destination-flight-info__column flex flex--align-start g-small">
        <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.FLIGHT_OFFER" />
        <div class="flex flex--column">
          <span class="font-heading-4 font-title-medium">
            {{ 'ondMarketing.destinationFlightInfo.startingFrom' | finLocalization }}
          </span>
          <span class="font-body-1">
            {{
              (isRoundTrip()
                ? 'ondMarketing.destinationFlightInfo.roundTrip'
                : 'ondMarketing.destinationFlightInfo.oneWay'
              ) | finLocalization
            }}
          </span>
          <span class="font-heading-3 font-headline-small">{{ price | finPrice }}</span>
        </div>
      </div>
    }

    @if (duration(); as duration) {
      <div class="destination-flight-info__column flex flex--align-start g-small">
        <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.CLOCK" />
        <div class="flex flex--column">
          <span class="font-heading-4 font-title-medium">
            {{ 'ondMarketing.destinationFlightInfo.flightTime' | finLocalization }}
          </span>
          <span class="font-body-1">
            {{ 'ondMarketing.destinationFlightInfo.approx' | finLocalization }}
          </span>
          <span class="font-heading-3 font-headline-small">{{ duration | finDuration | async }}</span>
        </div>
      </div>
    }

    @if (airportCodes().length) {
      <div class="destination-flight-info__column flex flex--align-start g-small">
        <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.AIRPORT" />
        <div class="flex flex--column">
          <span class="font-heading-4 font-title-medium">
            {{ 'ondMarketing.destinationFlightInfo.airports' | finLocalization }}
          </span>
          @if (cityName(); as cityName) {
            <span class="font-body-1">{{ cityName }}</span>
          }
          <span class="font-heading-3 font-headline-small">{{ airportCodes().join(', ') }}</span>
        </div>
      </div>
    }

    @if (isDirect()) {
      <div class="destination-flight-info__column flex flex--middle g-small">
        <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
        <span class="font-heading-4 font-title-medium">
          {{ 'ondMarketing.destinationFlightInfo.directFlights' | finLocalization }}
        </span>
      </div>
    }
  </div>
</section>
